module.exports = __webpack_public_path__ + "img/par.818f157a.svg";